// angular import
import { Component, effect, inject, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';

// project import
import { ConfigurationComponent } from 'src/app/@theme/layouts/configuration/configuration.component';
import { FooterComponent } from '../footer/footer.component';
import { Header } from '../header/header';
import { LTR, RTL, VERTICAL } from '../../const';
import { ThemeLayoutService } from '../../services/theme-layout.service';
import { MatDrawerContainer } from '@angular/material/sidenav';
import { AbleProConfig } from '../../../app-config';
import { filter } from 'rxjs';
import { Location } from '@angular/common';
import { LoadingOverlayComponent } from '../../../pages/loading-overlay/loading-overlay';


@Component({
  selector: 'app-empty',
  imports: [ConfigurationComponent, RouterModule, FooterComponent, Header, MatDrawerContainer, LoadingOverlayComponent],
  templateUrl: './empty.component.html',
  standalone: true,
  styleUrls: ['./empty.component.scss']
})
export class EmptyComponent implements OnInit {
  direction: string = RTL;
  private renderer = inject(Renderer2);
  private themeService = inject(ThemeLayoutService);
  private router = inject(Router);
  private location = inject(Location);
  rtlLayout!: boolean;
  rtlMode: boolean = false;
  currentLayout: string = VERTICAL;
  showBackButton: boolean = false;
  constructor() {
    this.rtlMode = AbleProConfig.isRtlLayout;
    this.currentLayout = AbleProConfig.layout;
    this.direction = this.rtlMode ? RTL : LTR;

    effect(() => {
      const layout = this.themeService.layout();
      queueMicrotask(() => {
        this.currentLayout = layout;
      });
    });

    effect(() => {
      const direction = this.themeService.directionChange();
      queueMicrotask(() => {
        this.rtlMode = direction === RTL;
        this.direction = this.rtlMode ? RTL : LTR;
      });
    });
  }

  ngOnInit() {
    this.renderer.addClass(document.body, 'numeryx-front-rtl');
    this.renderer.setAttribute(document.body, 'dir', 'rtl'); // <-- add this
    this.rtlLayout = true;
    this.themeService.directionChange.set(RTL);
    this.updateBackButton(this.router.url);
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      this.updateBackButton(event.urlAfterRedirects);
    });
  }
  private updateBackButton(url: string) {
    this.showBackButton = url !== '/welcome-page';
  }
  goBack() {
    this.location.back();
  }
}
